import { render, staticRenderFns } from "./mypage-dshop-order-dialog.vue?vue&type=template&id=bfd419d4&"
import script from "./mypage-dshop-order-dialog.vue?vue&type=script&lang=js&"
export * from "./mypage-dshop-order-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports